/** @jsx jsx */
import { Button } from './Button';
import { Heading } from './Heading';
import { Inline } from './Inline';
import { jsx } from './types';
import { LeftChevronIcon } from './Icon/individual-icons';

type HeaderProps = {
  title?: string;
  variant?: string;
  onBackButtonPress?: () => void;
};

export function MobileHeader(props: HeaderProps) {
  return (
    <Inline
      alignY="center"
      bg="backgroundSoft"
      pt="2"
      pb="2"
      px="2"
      sx={{ variant: 'layout.popup.mobileFilterHeader' }}
      className="MobileHeader"
    >
      <Button
        variant="icon"
        onClick={props.onBackButtonPress}
        sx={{ paddingLeft: '2', paddingRight: '2' }}
      >
        <LeftChevronIcon
          className="fr-icon fr-rotate"
          size={17}
          sx={{ stroke: 'primary', strokeWidth: '100px' }}
        />
      </Button>
      <Heading
        variant={props?.variant ?? 'fontSize8'}
        sx={{ textAlign: 'center', flex: 1, color: 'text' }}
      >
        {props.title || ''}
      </Heading>
    </Inline>
  );
}
